var path = '/templates/zenclerk_s/sites/interest_widget/interest_widget_navigation.html';
var html = "<a ui-sref=\"zenclerkS.project.interestWidget.results({apikey: vm.project.apikey})\" ui-sref-active=active>{{ 'sites.interestWidget.interestWidgetNavigation.haishin_kekka' | translate }}</a> <a ui-sref=\"zenclerkS.project.interestWidget.settings({apikey: vm.project.apikey})\" ui-sref-active=active>{{ 'sites.interestWidget.interestWidgetNavigation.settei' | translate }}</a>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_s_modules/zenclerk_s/sites/interest_widget/interest_widget_navigation.html
// module id = 1416
// module chunks = 0